module.exports = __webpack_public_path__ + "img/trade-icon-4.004d9b14.svg";